import { CaretDownIcon, CaretUpIcon } from '@change/ds-icons';

import { translationKey } from '@change-corgi/core/i18n';

import type { DynamicTaskShape, ToggleTaskListData } from '../../types';

export const DEFAULT_TASKS_DISPLAY_COUNT = 3;
export const DYNAMIC_TASKS_EXPANDED_STORAGE_KEY = 'starterDashboardV2_dynamicTasksExpanded';

const TOGGLE_LABELS = [
	translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.view_more_label'),
	translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.view_less_label'),
] as const;
const TOGGLE_ICONS = [
	<CaretDownIcon className="icon-strong align-middle" size={20} />,
	<CaretUpIcon className="icon-strong align-middle" size={20} />,
] as const;
const NEXT_EXPANDED_VALUES = ['true', null] as const;

function getToggleIndex(expanded: boolean): 0 | 1 {
	return Number(expanded) as 0 | 1;
}

export function getToggleTaskListData(allTasks: readonly DynamicTaskShape[], expanded: boolean): ToggleTaskListData {
	const i = getToggleIndex(expanded);

	return {
		showTaskListToggle: allTasks.length > DEFAULT_TASKS_DISPLAY_COUNT,
		toggleTaskListRemainingCount: allTasks.length - DEFAULT_TASKS_DISPLAY_COUNT,
		toggleTaskListIcon: TOGGLE_ICONS[i],
		toggleTaskListLabel: TOGGLE_LABELS[i],
		nextExpandedStorageValue: NEXT_EXPANDED_VALUES[i],
	};
}
